<template>
  <div>
    <div class="pa-0 ma-0">
      <div class="body-overall">
        <v-row style="padding-top:64px!important"></v-row>
        <div :class="getGextPanel" class="pt-6" style="margin:0px!important;">
          <div class="fonts-white container pl-0 pr-1">
            <div class="overlay-grey-web">
              <!-- Header Section -->
              <div class="billing-header">
                <div class="header-content">
                  <v-icon class="header-icon">mdi-receipt-text</v-icon>
                  <h1 class="header-title">Billing & Invoices</h1>
                </div>
                <p class="header-subtitle">
                  Manage your billing history and request invoices for your purchases
                </p>
              </div>

              <v-divider class="my-4" style="opacity:0.3;"></v-divider>

              <!-- Info Alert -->
              <v-alert
                type="info"
                variant="outlined"
                class="billing-info-alert mb-4"
                icon="mdi-information"
              >
                <div class="alert-content">
                  <div class="alert-title">Invoice Request Policy</div>
                  <div class="alert-text">
                    You can request invoices for paid services within 30 days of purchase. 
                    Make sure your invoice company data is filled in your profile settings.
                  </div>
                </div>
              </v-alert>

              <!-- Filters Section -->
              <div class="billing-section">
                <h2 class="section-title">
                  <v-icon left>mdi-filter</v-icon>
                  Filter Billing Data
                </h2>

                <div class="billing-filters">
                  <v-checkbox
                    v-model="allStats"
                    color="white"
                    class="all-data-checkbox"
                    hide-details
                  >
                    <template v-slot:label>
                      <span class="checkbox-label">Show All Data</span>
                    </template>
                  </v-checkbox>

                  <div class="date-range-picker">
                    <v-menu
                      :disabled="allStats"
                      v-model="menuFrom"
                      :close-on-content-click="false"
                      transition="scale-transition"
                    >
                      <template v-slot:activator="{ props }">
                        <v-text-field
                          v-model="formattedDateFrom"
                          label="From Date"
                          prepend-inner-icon="mdi-calendar"
                          readonly
                          v-bind="props"
                          :disabled="allStats"
                          class="date-field"
                          variant="outlined"
                          density="comfortable"
                          hide-details
                        >
                          <template v-slot:append-inner>
                            <v-btn
                              v-if="!allStats"
                              icon
                              size="x-small"
                              variant="text"
                              @click.stop="menuFrom = false"
                            >
                              <v-icon size="16">mdi-close</v-icon>
                            </v-btn>
                          </template>
                        </v-text-field>
                      </template>
                      <v-date-picker
                        v-model="dateFrom"
                        :max="dateTo"
                        @update:model-value="menuFrom = false"
                        color="white"
                        style="border:1px solid rgba(255,255,255,0.3);"
                      ></v-date-picker>
                    </v-menu>

                    <v-menu
                      :disabled="allStats"
                      v-model="menuTo"
                      :close-on-content-click="false"
                      transition="scale-transition"
                    >
                      <template v-slot:activator="{ props }">
                        <v-text-field
                          v-model="formattedDateTo"
                          label="To Date"
                          prepend-inner-icon="mdi-calendar"
                          readonly
                          v-bind="props"
                          :disabled="allStats"
                          class="date-field"
                          variant="outlined"
                          density="comfortable"
                          hide-details
                        >
                          <template v-slot:append-inner>
                            <v-btn
                              v-if="!allStats"
                              icon
                              size="x-small"
                              variant="text"
                              @click.stop="menuTo = false"
                            >
                              <v-icon size="16">mdi-close</v-icon>
                            </v-btn>
                          </template>
                        </v-text-field>
                      </template>
                      <v-date-picker
                        v-model="dateTo"
                        :min="dateFrom"
                        :max="new Date()"
                        @update:model-value="menuTo = false"
                        color="white"
                        style="border:1px solid rgba(255,255,255,0.3);"
                      ></v-date-picker>
                    </v-menu>
                  </div>
                </div>
              </div>

              <v-divider class="my-4" style="opacity:0.3;"></v-divider>

              <!-- Billing History Section -->
              <div class="billing-section">
                <h2 class="section-title">
                  <v-icon left>mdi-history</v-icon>
                  Billing History
                </h2>

                <!-- Empty State -->
                <div class="billing-empty-state">
                  <div class="empty-icon-wrapper">
                    <v-icon size="64" color="grey">mdi-receipt-text-outline</v-icon>
                  </div>
                  <h3 class="empty-title">No Billing Data</h3>
                  <p class="empty-subtitle">
                    You don't have any billing records yet. Once you make a purchase, your billing history will appear here.
                  </p>
                  <div class="empty-actions">
                    <v-btn
                      variant="outlined"
                      prepend-icon="mdi-cart"
                      @click="handleClickMenu('payment')"
                      class="empty-action-btn"
                    >
                      Buy Credits
                    </v-btn>
                  </div>
                </div>

                <!-- Future: Billing Table (when data exists) -->
                <!--
                <div class="billing-table">
                  <div class="table-header">
                    <div class="table-col">Date</div>
                    <div class="table-col">Service</div>
                    <div class="table-col">Amount</div>
                    <div class="table-col">Status</div>
                    <div class="table-col">Actions</div>
                  </div>
                  <div v-for="item in billingData" :key="item.id" class="table-row">
                    <div class="table-col">{{ formatDate(item.date) }}</div>
                    <div class="table-col">{{ item.service }}</div>
                    <div class="table-col">{{ formatAmount(item.amount) }}</div>
                    <div class="table-col">
                      <v-chip :color="getStatusColor(item.status)" size="small">
                        {{ item.status }}
                      </v-chip>
                    </div>
                    <div class="table-col">
                      <v-btn
                        variant="text"
                        size="small"
                        prepend-icon="mdi-file-download"
                        :disabled="!canRequestInvoice(item)"
                        @click="requestInvoice(item)"
                      >
                        Invoice
                      </v-btn>
                    </div>
                  </div>
                </div>
                -->
              </div>

              <!-- Invoice Settings Section -->
              <div class="billing-section mt-6">
                <h2 class="section-title">
                  <v-icon left>mdi-domain</v-icon>
                  Invoice Company Data
                </h2>

                <div class="invoice-settings-card">
                  <div class="settings-info">
                    <v-icon size="20" color="white" class="mr-2">mdi-information</v-icon>
                    <p class="info-text">
                      To request invoices, please ensure your company data is complete in your profile settings.
                    </p>
                  </div>
                  <v-btn
                    variant="outlined"
                    prepend-icon="mdi-account-edit"
                    @click="handleClickMenu('settings')"
                    class="settings-btn"
                  >
                    Update Company Data
                  </v-btn>
                </div>
              </div>

            </div>
          </div>
        </div>
        <v-row
          :style="(this.isMobileXs || this.isMobilePlayer3) ? 'padding-top:170px!important' : 'padding-top:123px!important'"></v-row>
      </div>
    </div>
  </div>
</template>

<script>
import { useMobile } from '../composables/useMobile.js'
import { useMobilePlayer3 } from '../composables/useMobilePlayer3.js'
import { useMobileXs } from '../composables/useMobileXs.js'
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";


export default {
  setup() {
    const isMobile = useMobile()
    const isMobileXs = useMobileXs()
    const isMobilePlayer3 = useMobilePlayer3();

    const notify = (message) => {
      toast(message, {
        theme: "dark",
        type: "success",
        position: "bottom-center",
        closeOnClick: false,
        pauseOnHover: false,
        autoClose: 1500,
        transition: "flip",
        dangerouslyHTMLString: true,
      });
    };

    const notifyError = (message) => {
      toast(message, {
        theme: "dark",
        type: "error",
        position: "bottom-center",
        closeOnClick: false,
        pauseOnHover: false,
        autoClose: 3000,
        transition: "flip",
        dangerouslyHTMLString: true,
      });
    };

    return { isMobile, isMobileXs, notify, notifyError, isMobilePlayer3 }
  },
  name: 'Billing',

  components: {

  },
  data: () => ({
    navbar: false,
    user: null,
    menuFrom: false,
    menuTo: false,
    dateFrom: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
    dateTo: new Date(),
    allStats: true,

  }),
  mounted() {
    window.addEventListener('resize', this.checkScreenSize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkScreenSize);
  },
  beforeUnmount() {

  },
  destroyed() {
  },
  watch: {
    '$store.state.user': function () {
      this.user = this.$store.getters.getUserData;
    },
  },
  computed: {
    isfullScreen() {
      if (this.isMobile && this.isMobileXs) {
        return false;
      } else {
        return true;
      }
    },
    isLogged() {
      return this.$store.getters.getUserData != null
    },
    isDesktop() {
      if (!this.navbar) {
        return true;
      } else {
        return false;
      }
    },
    getGextPanel() {
      if (this.navbar) {
        if (this.isMobileXs) {
          return 'textPanelMobileXs'
        } else {
          return 'textPanelMobile';
        }
      } else return 'textPanel';
    },
    formattedDateFrom() {
      return this.dateFrom.toLocaleDateString();
    },
    formattedDateTo() {
      return this.dateTo.toLocaleDateString();
    },

  },
  created() {
    if (this.$store.getters.getUserData != null) {
      this.user = this.$store.getters.getUserData;

      if (window.innerWidth > 768) {
        this.navbar = false;
      } else {
        this.navbar = true;
      }
    }
  },
  methods: {

    checkScreenSize() {
      if (window.innerWidth > 768) {
        this.navbar = false;
      } else {
        this.navbar = true;
      }
    },
    handleClickMenu(link) {
      if (link === 'TryMuzE') {
        window.location.href = 'https://muze.muzible.com/';
      } else if (link === 'TryVerse') {
        window.location.href = 'https://verse.muzible.com/';
      } else {
        if (this.$route.name !== link) {
          this.$router.push({ name: link });
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@use './css/styles.scss';

/* Billing Header */
.billing-header {
  margin-bottom: 24px;
}

.header-content {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 12px;
}

.header-icon {
  font-size: 48px !important;
  color: white;
}

.header-title {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 42px;
  font-weight: 700;
  color: white;
  margin: 0;
}

.header-subtitle {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.7);
  margin: 0;
  line-height: 1.5;
}

/* Info Alert */
.billing-info-alert {
  background: rgba(33, 150, 243, 0.1) !important;
  border: 1px solid rgba(33, 150, 243, 0.4) !important;
  border-radius: 12px !important;
  padding: 16px !important;

  :deep(.v-alert__content) {
    color: white !important;
  }
}

.alert-content {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.alert-title {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 18px;
  font-weight: 700;
  color: white;
  letter-spacing: 0.5px;
}

.alert-text {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 15px;
  color: rgba(255, 255, 255, 0.9);
  line-height: 1.5;
}

/* Section */
.billing-section {
  margin-bottom: 40px;
}

.section-title {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 28px;
  font-weight: 600;
  color: white;
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  gap: 12px;
}

/* Billing Filters */
.billing-filters {
  background: linear-gradient(145deg, rgba(26, 26, 26, 0.95), rgba(18, 18, 18, 0.95));
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 20px;
  transition: all 0.3s ease;
}

.billing-filters:hover {
  border-color: rgba(255, 255, 255, 0.2);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
}

.all-data-checkbox {
  margin-bottom: 16px;
}

:deep(.all-data-checkbox .v-label) {
  color: white !important;
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 16px !important;
  font-weight: 500;
}

.checkbox-label {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 16px;
  font-weight: 500;
  color: white;
}

.date-range-picker {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

@media (max-width: 600px) {
  .date-range-picker {
    grid-template-columns: 1fr;
  }
}

.date-field {
  font-family: "Darker Grotesque", sans-serif !important;
}

:deep(.date-field .v-field) {
  background: rgba(255, 255, 255, 0.05) !important;
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
  border-radius: 8px !important;
  transition: all 0.3s ease;
}

:deep(.date-field .v-field:hover:not(.v-field--disabled)) {
  border-color: rgba(255, 255, 255, 0.4) !important;
}

:deep(.date-field .v-field--focused) {
  border-color: rgba(255, 255, 255, 0.6) !important;
}

:deep(.date-field .v-label) {
  color: rgba(255, 255, 255, 0.7) !important;
  font-family: "Darker Grotesque", sans-serif !important;
}

:deep(.date-field .v-field__input) {
  color: white !important;
  font-family: "Darker Grotesque", sans-serif !important;
  font-weight: 500;
}

:deep(.date-field.v-field--disabled .v-field) {
  opacity: 0.5;
}

/* Empty State */
.billing-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  padding: 60px 20px;
  text-align: center;
  background: linear-gradient(145deg, rgba(26, 26, 26, 0.5), rgba(18, 18, 18, 0.5));
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
}

.empty-icon-wrapper {
  margin-bottom: 24px;
  animation: float 3s ease-in-out infinite;
}

@keyframes float {
  0%, 100% { transform: translateY(0px); }
  50% { transform: translateY(-10px); }
}

.empty-title {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 32px;
  font-weight: 700;
  color: white;
  margin-bottom: 12px;
}

.empty-subtitle {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 32px;
  max-width: 500px;
  line-height: 1.6;
}

.empty-actions {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  justify-content: center;
}

.empty-action-btn {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  border-color: rgba(255, 255, 255, 0.3) !important;
  padding: 0 24px !important;
}

.empty-action-btn:hover {
  background: rgba(255, 255, 255, 0.1) !important;
  border-color: rgba(255, 255, 255, 0.5) !important;
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
}

/* Invoice Settings Card */
.invoice-settings-card {
  background: linear-gradient(145deg, rgba(26, 26, 26, 0.95), rgba(18, 18, 18, 0.95));
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  transition: all 0.3s ease;
}

.invoice-settings-card:hover {
  border-color: rgba(255, 255, 255, 0.2);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
}

@media (max-width: 768px) {
  .invoice-settings-card {
    flex-direction: column;
    align-items: flex-start;
  }
}

.settings-info {
  display: flex;
  align-items: flex-start;
  flex: 1;
}

.info-text {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 15px;
  color: rgba(255, 255, 255, 0.85);
  line-height: 1.5;
  margin: 0;
}

.settings-btn {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 14px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  border-color: rgba(255, 255, 255, 0.3) !important;
  flex-shrink: 0;
}

.settings-btn:hover {
  background: rgba(255, 255, 255, 0.1) !important;
  border-color: rgba(255, 255, 255, 0.5) !important;
}

/* Billing Table (for future use) */
.billing-table {
  background: linear-gradient(145deg, rgba(26, 26, 26, 0.95), rgba(18, 18, 18, 0.95));
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  overflow: hidden;
}

.table-header {
  display: grid;
  grid-template-columns: 1fr 1.5fr 1fr 1fr 1fr;
  gap: 16px;
  background: rgba(255, 255, 255, 0.08);
  padding: 16px 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  font-family: "Darker Grotesque", sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.7);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.table-row {
  display: grid;
  grid-template-columns: 1fr 1.5fr 1fr 1fr 1fr;
  gap: 16px;
  padding: 16px 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  transition: all 0.3s ease;
  font-family: "Darker Grotesque", sans-serif;
  font-size: 15px;
  color: white;
}

.table-row:last-child {
  border-bottom: none;
}

.table-row:hover {
  background: rgba(255, 255, 255, 0.05);
}

.table-col {
  display: flex;
  align-items: center;
}

@media (max-width: 1024px) {
  .table-header,
  .table-row {
    grid-template-columns: 1fr;
    gap: 8px;
  }
  
  .table-col {
    padding: 4px 0;
  }
}

/* Animations */
@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.billing-filters,
.billing-empty-state,
.invoice-settings-card {
  animation: slideIn 0.4s ease forwards;
}

.billing-info-alert {
  animation: slideIn 0.3s ease forwards;
}

/* Override Vuetify */
:deep(.v-btn:hover) > .v-btn__overlay {
  --v-hover-opacity: 0.1;
  opacity: 0.1;
}

:deep(.v-list-item:hover) > .v-list-item__overlay {
  --v-hover-opacity: 0.1;
  opacity: 0.1;
}

:deep(.v-chip) {
  font-family: "Darker Grotesque", sans-serif !important;
  font-weight: 600 !important;
}
</style>